import * as actionTypes from './actionTypes';

export default () => ({ type: actionTypes.LOADED });
